<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <dashboard-header></dashboard-header>
        <check-fto></check-fto>
        <dashboard-packets></dashboard-packets>
        <dashboard-footer></dashboard-footer>
    </b-col>
</template>

<script>
    import CheckFto from './calculator/CheckFTO.vue';
    import DashboardHeader from './dashboard-first-time/DashboardHeader.vue';
    import DashboardPackets from './dashboard-first-time/DashboardPackets.vue';
    import DashboardFooter from './start-packet/StartPacketFooter.vue';

    export default {
        components: { CheckFto, DashboardHeader, DashboardPackets, DashboardFooter }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/DashboardFirstTimeContent.vue